module.exports = __webpack_public_path__ + "img/mobile-menu-roulette.0172426b.webp";